import { render, staticRenderFns } from "./AppIntroduction.vue?vue&type=template&id=5c999fb9&scoped=true&"
import script from "./AppIntroduction.vue?vue&type=script&lang=js&"
export * from "./AppIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./AppIntroduction.vue?vue&type=style&index=0&id=5c999fb9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c999fb9",
  null
  
)

/* custom blocks */
import block0 from "./AppIntroduction.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports